import { render, staticRenderFns } from "./configForm.vue?vue&type=template&id=c7ccf108&scoped=true&"
import script from "./configForm.vue?vue&type=script&lang=js&"
export * from "./configForm.vue?vue&type=script&lang=js&"
import style0 from "./configForm.vue?vue&type=style&index=0&id=c7ccf108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ccf108",
  null
  
)

export default component.exports